import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../PersonFieldLabel';

function CityField() {
  return (
    <div className="my-4 w-full">
      <div className="block mr-6">
        <div className="w-full">
          <PersonFieldLabel htmlFor="city-input">City</PersonFieldLabel>
        </div>
        <div className="w-full">
          <FormikInput id="city-input" name="cityName" />
        </div>
      </div>
    </div>
  );
}

export default CityField;
